import React from "react";
import { UseMutationResult } from "react-query";
import BaamerProject from "../../../models/classes/baamer-project.ts";
import ProjectLock from "../../../models/classes/project-lock.ts";
import BaamerProjectDto from "../../../models/interfaces/dtos/baamer-project-dto.ts";
import FlowMode from "@/models/enums/flow-mode.ts";

export interface ProjectsContextProps {
    projects: BaamerProject[] | undefined;
    isLoading: boolean;
    error: unknown;

    createProjectMutation: UseMutationResult<BaamerProjectDto | null, unknown, {
        name: string;
        localisationId: number;
        flowMode: FlowMode
    }>

    refetchProjectIds: (projectId: string) => Promise<void>;

    hydrateProjectLock: (projectId: string, projectLock: ProjectLock) => void;
    lockProject: (projectId: string) => void;
    unlockProject: (projectId: string) => void;
}

export const ProjectsContext = React.createContext<ProjectsContextProps | undefined>(undefined);